// Colors
export const COLOR_PRIMARY = "#000000";
export const COLOR_SECONDARY = "#4285F4";
export const COLOR_TERTIARY = "#FFFFFF";
export const COLOR_ERROR = "#9C0E0E";
export const COLOR_WARNING = "#F6AF43";
export const COLOR_SUCCESS = "#5CC37A";
export const COLOR_INFO = "#FEE7DB";
export const COLOR_LINK = "#4285F4";
export const COLOR_DISABLED = "#D9D9D9";
export const COLOR_DIVIDER = "#EEEEF6";
export const COLOR_DIVIDER_DARK = "#0714431a";
export const COLOR_APP_TEXT = "#071443";
export const COLOR_APP_TEXT_LIGHT = "rgba(7, 20, 67, 0.60)";
export const COLOR_GREEN_TEXT = "#245631";
export const COLOR_GREEN_BORDER = "#008770";
export const COLOR_GREEN_BACKGROUND = "#e2fae8";
export const COLOR_GREEN_CHECKBOX_HOVER = "#F3FAF5";
export const COLOR_LIGHT_BLUE_CHECKBOX_HOVER = "#F4F7FF";
export const COLOR_GREY_BORDER = "#00000033";
export const COLOR_PAGE_BACKGROUND = "#FAFAFD";
export const COLOR_MENU_HOVER = "#EAEAFE";
export const COLOR_FINANCIAL_ITEM_BACKGROUND = "#F6F6FA";
export const COLOR_PRIMARY_BUTTON = "#302B5D";
export const COLOR_GREY_BACKGROUND = "#E1DCDC";
export const COLOR_LILAC = "#9E80ED";
export const COLOR_PURPLE_BACKGROUND = "#F4ECFE";
export const COLOR_PURPLE_BORDER = "#9747F4";
export const COLOR_YELLOW_STAR = "#FFBF5E";
export const COLOR_ERROR_COMPONENT_TEXT = "#EB4335";
export const COLOR_OVERLAY_BACKGROUND = "#07124333";
export const COLOR_CART_SUMMARY_FEATURES_BACKGROUND = "#07144305";
export const COLOR_DISABLED_CHECKBOX = "#07144380";
export const COLOR_PRODUCT_INCLUDED_IN_BUNDLE_TEXT = "#21880C";
export const COLOR_BLUE_TEXT = "#0874D9";
export const COLOR_PAID_TEXT = "#21880C";
export const COLOR_DUE_TEXT = "#DD5E79";
export const COLOR_PROMO_CODE_ERROR = "#AC258E";
export const COLOR_WARNING_TRIANGLE = "#FFCF07";
export const COLOR_PROMO_CODE_SUCCESS = "#8423EA";
export const COLOR_PURPLE_TEXT = "#9747FE";
export const COLOR_UNDER_REVIEW_TEXT = "#3A8CAA";
export const COLOR_DEACTIVATED_TEXT = "#C34687";
export const COLOR_DROPDOWN_FILTER_BACKGROUND = "#F9F9FB";
export const COLOR_ERROR_BACKGROUND = "#FFF1F1";
export const COLOR_ERROR_BACKGROUND_POPUP = "#FFE4E4";
export const COLOR_ERROR_BORDER = "#DE2A2A";
export const COLOR_DESCRIPTION_TEXT = "#6b7280";
export const COLOR_PENDING_ACTION_BACKGROUND = "#F2ECFE";
export const COLOR_GREY_01 = "#798492";
export const COLOR_DROPDOWN_TEXT_SELECTED = "#7949FF";
export const COLOR_WARNING_TEXT = "#B34200";
export const COLOR_INPUT_DEFAULT_BORDER = "#ADB2C7";
export const COLOR_INPUT_BORDER_FOCUSED = "#0F2163";
export const COLOR_INPUT_BORDER_HOVER = "rgba(15, 33, 99, 0.70)";
export const COLOR_SECONDARY_BUTTON_DISABLED_BORDER = "#E4E3EC";
export const COLOR_SECONDARY_BUTTON_DISABLED_TEXT = "rgba(15, 33, 99, 0.30)";
export const COLOR_NAV_ITEM_NUMBER = "#EFEFF5";
export const COLOR_CLOSE_BUTTON_BACKGROUND = "#F9F9FC";
export const COLOR_PROMO_CODE_APPLIED_GREEN_BACKGROUND = "#DFF4F0";
export const COLOR_PROMO_CODE_APPLIED_GREEN_TEXT = "#0B5246";

// Button and Input Gradients and Colors
export const BUTTON_PRIMARY_COLOR_GRADIENT =
  "linear-gradient(90deg, #302B5D 19.43%, #1B1454 97.89%);";
export const BUTTON_PRIMARY_GRADIENT =
  "linear-gradient(90deg, #E8806A -0.12%, #BE4DA1 41.07%, #301A96 95.17%)";
export const BUTTON_PRIMARY_GRADIENT_HOVER =
  "linear-gradient(97deg, #FFEEE9 15.19%, #EDE4FF 80.05%)";
export const BUTTON_PRIMARY_GRADIENT_SELECTED =
  "linear-gradient(97deg, #FFE8D8 10.96%, #ECCCFF 115.97%)";
export const DANGER_BUTTON_GRADIENT =
  "linear-gradient(290deg, rgba(221, 94, 121, 0.50) -11.95%, rgba(206, 70, 62, 0.50) 42.48%)";
export const BUTTON_SECONDARY_COLOR = " #FFFFFF";
export const BUTTON_DISABLED_COLOR = "#D1D8DF";
export const BUTTON_GREY_BORDER = "#EAE9E9";
export const BUTTON_FILTER_SELECTED_COLOR = "#ECECEF";
export const BUTTON_FILTER_HOVER_COLOR = "#EAEAFE";
export const PLACEHOLDER_TEXT_COLOR = "#07144399";
export const DISABLED_INPUT_FIELD_COLOR = "#F6F6FC";

// Warning Success Gradients
export const WARNING_GRADIENT =
  "linear-gradient(126.28deg, #FFECE3 12.24%, #FDDCCA 96.31%)";
export const SUCCESS_GRADIENT =
  "linear-gradient(126.28deg, #e3fef9 12.24%, #cbf9e1 96.31%)";

// Gradients - Icons, Popups, Backgrounds, etc.
export const ICON_PRIMARY_GRADIENT_SELECTED =
  "linear-gradient(139deg, #FFE8D8 -4.24%, #ECCCFF 102.92%)";
export const ICON_PRIMARY_GRADIENT_HOVER =
  "linear-gradient(139deg, #FFEEE9 3.95%, #EDE4FF 94.47%)";
export const ICON_HEADER_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(320deg, #6CB9FF -47.63%, #EFDDFC 87.71%)";
export const ICON_BLUE_CONTAINER_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(320deg, #6C95FF -47.63%, #C7FFFC 87.71%)";
export const ICON_PEACH_CONTAINER_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(165deg, #FFE1D2 4.92%, #FDB7AF 89.51%)";
export const ICON_AQUA_CONTAINER_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(163deg, #8AE1F4 -1.98%, #B2EFE9 88.33%)";
export const ICON_LIGHT_PINK_CONTAINER_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(145deg, #FDE1DC 5.09%, #CFACF4 92.36%)";
export const BLUE_PURPLE_CONTAINER_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(94deg, #C7E6FA 6.03%, #F5EBFF 108.19%)";
export const VIDEO_CONTAINER_COLOR_GRADIENT =
  "linear-gradient(90deg, #F2ECFE -6.68%, #DAE3FF 106.11%)";
export const INFORMATIONAL_MESSAGE_POPUP_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(302deg, #F2ECFE 12.66%, #DAE3FF 83.36%)";
export const WARNING_MESSAGE_POPUP_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(126.07deg, #FFECE3 19.39%, #FDDCCA 83.3%)";
export const SKELETON_BACKGROUND_GRADIENT =
  "linear-gradient(139deg, #E1DCDC 3.95%, #B9BEC7 94.47%)";
export const REPRESENTATION_TAG_GRADIENT =
  "linear-gradient(94deg, #D3F1FD 6.03%, #DFD8FF 108.19%)";
export const Q_A_TAG_GRADIENT =
  "linear-gradient(94deg, #F1D4F5 6.03%, #FBCCE3 108.19%)";
export const PROTIP_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(93deg, #FEE7DB 0.47%, #E9EEFF 58.32%)";
export const EXAMPLE_SCENARIO_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(93deg, #DBF6FE -2.85%, #E3EEFF 74.39%)";
export const SECTION_ACCESS_BLOCKER_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(111deg, #FBECEA 13.58%, #DAE3FF 98.42%)";
export const POPUP_WARNING_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(126deg, #FFECE3 12.24%, #FDDCCA 96.31%)";
export const SUCCESS_POPUP_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(180deg, #DEFCF4 0%, #B3EDD0 100%)";
export const CLIENT_ICON_BACKGROUND_GRADIENT =
  "linear-gradient(139deg, #8AE1F4 -4.24%, #B2EFE9 102.92%)";
export const LIMITED_TIME_OFFER_GRADIENT =
  "linear-gradient(270deg, #6CB9FF -62.33%, #EFDFFC 86.47%)";
export const CART_SUMMARY_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(156deg, rgba(255, 242, 231, 0.91) 8.53%, #E8D6F3 107.19%)";
export const PRODUCT_ICON_DISABLED_COLOR_GRADIENT =
  "linear-gradient(165deg, rgba(87, 100, 146, 0.38) 4.92%, rgba(84, 92, 121, 0.79) 89.51%)";
export const CART_SUMMARY_FLOATING_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(96deg, #FCF5EF -40.84%, #F9F1FE 115.61%)";
export const ATTORNEY_SERVICES_CARD_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient( #FFF2E7 8.53%, #E8D6F3 107.19%)";
export const STRIPE_LOGO_BOX_GRADIENT =
  "linear-gradient(320deg, #9CBEF9 0%, #9A2AE6 100%)";
export const PROCESS_OVERVIEW_BACKGROUND_COLOR_GRADIENT =
  "linear-gradient(171deg, #FFF2E7 -3.45%, #E8D6F3 105.31%)";
export const ICON_OCEAN_MIST_COLOR_GRADIENT =
  "linear-gradient(165deg, #93E3F1 4.92%, #B0EEEA 89.51%)";

// Fonts
export const HEADER_FONT_FAMILY = "Area Normal, sans-serif";
export const TEXT_FONT_FAMILY = "Poppins, sans-serif";

// Font Sizes
export const FONT_SIZE_HEADER = "32px";
export const FONT_SIZE_HEADER2 = "24px";
export const FONT_SIZE_XSMALL = "8px";
export const FONT_SIZE_XSMALL_MOBILE = "8px";
export const FONT_SIZE_SMALL = "14px";
export const FONT_SIZE_SMALL_MOBILE = "14px";
export const FONT_SIZE_MEDIUM = "16px";
export const FONT_SIZE_MEDIUM_MOBILE = "14px";
export const FONT_SIZE_LARGE = "18px";
export const FONT_SIZE_LARGE_MOBILE = "16px";
export const FONT_SIZE_XLARGE = "24px";
export const FONT_SIZE_XLARGE_MOBILE = "20px";
export const FONT_SIZE_HEADER_MOBILE = "24px";

export const LINE_HEIGHT_DEFAULT = "24px";
export const LINE_HEIGHT_SMALL = "16px";
export const LINE_HEIGHT_XLARGE = "32px";
export const BORDER_RADIUS_DEFAULT = "14px";

export const MOBILE_BREAKPOINT = 768;
export const MOBILE_SCREEN = `@media screen and (max-width: ${MOBILE_BREAKPOINT}px)`;

export const TWO_COLUMN_CONTAINER_BREAKPOINT = 1120;
export const TWO_COLUMN_CONTAINER_SCREEN = `@media screen and (max-width: ${TWO_COLUMN_CONTAINER_BREAKPOINT}px)`;

export const PAYMENT_PAGE_FIRST_BREAKPOINT = 1304;
export const PAYMENT_PAGE_FIRST_BREAKPOINT_SCREEN = `@media screen and (max-width: ${PAYMENT_PAGE_FIRST_BREAKPOINT}px)`;

export const PAYMENT_PAGE_SECOND_BREAKPOINT = 816;
export const PAYMENT_PAGE_SECOND_BREAKPOINT_SCREEN = `@media screen and (max-width: ${PAYMENT_PAGE_SECOND_BREAKPOINT}px)`;

export const NAV_Z_INDEX = 8;
export const HEADER_Z_INDEX = 7;

export interface IconProps {
  size?: IconSize | SkeletonIconSize;
  color?: string;
}

export enum IconSize {
  XS = "12",
  S = "16",
  M = "20",
  L = "24",
  XL = "32",
  XXL = "56",
  XXXL = "80",
}

export enum SkeletonIconSize {
  S = "72",
  L = "200",
}

// Color constants for icon backgrounds
export const GROUP_ICON_COLORS = {
  BLUE_PURPLE: ICON_HEADER_BACKGROUND_COLOR_GRADIENT,
  BLUE: ICON_BLUE_CONTAINER_BACKGROUND_COLOR_GRADIENT,
  PEACH: ICON_PEACH_CONTAINER_BACKGROUND_COLOR_GRADIENT,
  AQUA: ICON_AQUA_CONTAINER_BACKGROUND_COLOR_GRADIENT,
  LIGHT_PINK: ICON_LIGHT_PINK_CONTAINER_BACKGROUND_COLOR_GRADIENT,
} as const;

// Common Values
export enum SPACING {
  SM = "8px",
  MD = "16px",
  LG = "24px",
  XL = "40px",
}

export const BORDER_RADIUS_MEDIUM = "16px";

export const FLEX_COLUMN = `
  display: flex;
  flex-direction: column;
`;

export const FLEX_ROW = `
  display: flex;
  flex-direction: row;
`;

export const QUESTIONNAIRE_INPUT_PLACEHOLDER_TEXT = "Enter answer here…";

// Box Shadow Constants
export const BOX_SHADOW_SMALL = "0px 2px 5px rgba(0, 0, 0, 0.03)";
export const BOX_SHADOW_MEDIUM = "0px 4px 10px rgba(0, 0, 0, 0.04)";
export const BOX_SHADOW_LARGE = "0px 8px 16px rgba(0, 0, 0, 0.1)";
export const BOX_SHADOW_BUTTON = "0px 4px 20px rgba(0, 0, 0, 0.06)";
export const BOX_SHADOW_BUTTON_HOVER = "0px 4px 20px rgba(0, 0, 0, 0.12)";
export const BOX_SHADOW_ELEVATED = "0px 8px 32px rgba(0, 0, 0, 0.06)";
